import "./SchedulePollyDialog.scss";

import { Button, Divider, Flex } from "@fluentui/react-northstar";
import FormState from "@shopify/react-form-state";
import React from "react";

import { PollyDialog } from "../../../_shared/components/PollyDialog";
import { SchedulePollyField } from "./SchedulePollyField";

type SchedulePollyProps = {
  open: boolean;
  rrule: string;
  sendAt: Date;
  header?: React.ReactNode;
  recuringRequired?: boolean;
  hideRecurring?: boolean;
  onCancel: () => void;
  onSave: (sendAt: Date, rrule: string | undefined) => void;
};

export const SchedulePollyDialog: React.FC<SchedulePollyProps> = ({
  onCancel,
  onSave,
  rrule,
  sendAt,
  open,
  header,
  recuringRequired,
  hideRecurring,
}) => {
  return (
    <PollyDialog
      onCancel={onCancel}
      header={header || "Schedule polly"}
      open={open}
      minHeight="40vh"
    >
      <div>
        <FormState
          initialValues={{
            rrule,
            sendAt,
          }}
          onSubmit={async ({ fields }) => {
            onSave(fields.sendAt.value, fields.rrule.value || undefined);
          }}
        >
          {({ fields, submit, submitting }) => {
            return (
              <Flex column gap="gap.medium" className="schedule-polly-dialog">
                <SchedulePollyField
                  rrule={fields.rrule}
                  sendAt={fields.sendAt}
                  column
                  rruleRequired={recuringRequired}
                  hideRecurring={hideRecurring}
                />

                <Divider />
                <Flex>
                  <Flex.Item>
                    <Button onClick={() => onCancel()} disabled={submitting} content="Cancel" />
                  </Flex.Item>
                  <Flex.Item push>
                    <Button onClick={submit} content="Save" primary loading={submitting} />
                  </Flex.Item>
                </Flex>
              </Flex>
            );
          }}
        </FormState>
      </div>
    </PollyDialog>
  );
};
